import { Dimensions, StyleSheet } from 'react-native'
import styled from 'styled-components/native'

import ProgressBarCircle from 'APP/Components/ProgressBarCircle'
import { isWeb } from 'APP/Helpers/checkPlatform'
import { Colors, Metrics } from '../../Themes'
import Fonts from '../../Themes/Fonts'

export const DAY_ITEM_SIZE = 38
export const DAY_ITEM_BORDER_WIDTH = 3
export const DAY_ITEM_OFFSET = DAY_ITEM_SIZE + DAY_ITEM_BORDER_WIDTH

export const WEEK_ITEM_SIZE = Dimensions.get('window').width - DAY_ITEM_SIZE

interface DayProgressProps {
  $isAfter: boolean
  $isBefore: boolean
  $isCurrent: boolean
}

export const DayProgress = styled(ProgressBarCircle).attrs(
  ({ $isAfter, $isBefore, $isCurrent }: DayProgressProps) => ({
    children: undefined,
    primaryColor: $isAfter ? Colors.buttonSecondaryDisabled : undefined,
    primaryOpacity: $isAfter ? 0.5 : 1,
    textColor: $isAfter ? Colors.buttonSecondaryDisabled : undefined,
    textFontSize: Fonts.size.regular,
    textStyles: $isBefore ? Fonts.style.subheader : $isCurrent ? Fonts.style.button : undefined,
  })
)<DayProgressProps>``

export const SelectedDayIndicator = styled.View`
  margin-top: 6px;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background-color: ${Colors.text};
  align-self: center;
`

export const FullSizeTouchTarget = styled.View.attrs({
  style: StyleSheet.absoluteFill,
})``

export default StyleSheet.create({
  container: {
    paddingLeft: Metrics.baseMargin,
    paddingRight: Metrics.baseMargin / 2,
  },
  weekItemContainer: {
    backgroundColor: Colors.appBg,
    paddingBottom: Metrics.baseMargin * 1.25,
    paddingHorizontal: Metrics.baseMargin * 0.375,
    display: 'flex',
    flexDirection: 'row',
    width: isWeb() ? 'auto' : WEEK_ITEM_SIZE,
    justifyContent: 'space-between',
  },
})
